/* eslint-disable no-console */
import React from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import CustomModal from "../../../../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../../../../Common/Svgs/CloseIcon";
import OperationsIcon from "../../../../../../Common/Svgs/OperationsIcon";
import {
  SESSION_STATUS,
  SESSION_TYPE_NAME,
} from "../../../../../Sessions/constants";
import getScheduleStatus from "../Common/getScheduleStatus";

const ScheduleSessionModal = ({ visible, onCancel }) => {
  const { scheduleSessionModal } = useSelector((state) => state.users);

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="460px">
      <div
        className="p-6"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-start justify-between pb-4 border-b border-light-grey">
          <div>
            <p className="font-poppins font-medium text-base leading-[100%] capitalize">
              {scheduleSessionModal?.data?.name}
            </p>

            <p className="mt-1 font-aileron font-normal text-xs leading-[100%] text-dark-gray">
              {scheduleSessionModal?.data?.date
                ? dayjs(scheduleSessionModal?.data?.date).format("DD MMM YYYY")
                : ""}
            </p>
          </div>

          <button type="button" onClick={onCancel}>
            <CloseIcon className="stroke-dark-gray w-6 h-6" />
          </button>
        </div>

        <div className="mt-4 space-y-4">
          {scheduleSessionModal?.data?.sessions?.map((item) => {
            return (
              <div
                key={item}
                className="bg-[#F8F2E0] p-3 flex items-start justify-between rounded-xl h-[70px]"
              >
                <div>
                  <div className="flex items-center gap-x-1.5 h-[26px]">
                    <OperationsIcon size={16} className="text-black" />
                    <p className="font-poppins text-base font-medium leading-[100%] text-black">
                      {item?.id}
                    </p>
                  </div>

                  <div className="mt-1.5 flex items-center gap-x-1.5 font-aileron font-semibold text-xs leading-[100%] text-dark-gray">
                    <p>{SESSION_TYPE_NAME[item?.activityType]}</p>
                    <div className="w-px h-[7px] bg-dark-gray" />
                    <p className="">
                      {item?.status === SESSION_STATUS.ONGOING
                        ? "Started At"
                        : ""}{" "}
                      {item?.status === SESSION_STATUS.UPCOMING
                        ? item?.timeSlot
                        : dayjs(item?.startTime).format("hh:mm A")}{" "}
                      {item?.status === SESSION_STATUS.COMPLETED
                        ? `- ${dayjs(item?.endTime).format("hh:mm A")}`
                        : null}
                    </p>
                  </div>
                </div>

                <div>
                  {getScheduleStatus({ type: "session", status: item.status })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </CustomModal>
  );
};

export default ScheduleSessionModal;
